// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TJ_XM","largestCol":"styles_largestCol__MSzMp","smallestCol":"styles_smallestCol__1EnKj"};